import { UseGetApiSimple, UsePostApi, UsePutApi, UsePutApiRaw } from "beaktShared/services/crudeApiService";
import { getTokenCookie } from "beaktShared/services/session";

const ENDPOINT = "ParcelamentoRoyalties";
const tenantId = window.location.host.split(":")[0].split(".")[0];

const buildQueryString = (params) => {
    const parts = Object.keys(params)
        .filter((key) => params[key] !== null && params[key] !== undefined && params[key] !== "")
        .map((key) => `${key}=${encodeURIComponent(params[key])}`);
    return parts.length > 0 ? `?${parts.join("&")}` : "";
};

const getByEstabelecimento = (estabelecimentoId, dataIni, dataFim) => {
    const query = buildQueryString({
        dataIni: dataIni ? dataIni.toISOString() : null,
        dataFim: dataFim ? dataFim.toISOString() : null,
    });
    return UseGetApiSimple(`${ENDPOINT}/byestabelecimento/${estabelecimentoId}${query}`, 0);
};

const criar = (dto) => UsePostApi(ENDPOINT, dto);

const editar = (id, dto) => UsePutApi(`${ENDPOINT}/`, id, dto);

const getParcelas = (parcelamentoRoyaltieId) =>
    UseGetApiSimple(`${ENDPOINT}/${parcelamentoRoyaltieId}/parcelas`, 0);

const atualizarStatusParcela = (parcelamentoRoyaltieParcelaId, dto) =>
    UsePutApiRaw(`${ENDPOINT}/parcela/`, `${parcelamentoRoyaltieParcelaId}/status`, dto);

const getLogs = (parcelamentoRoyaltieId) =>
    UseGetApiSimple(`${ENDPOINT}/${parcelamentoRoyaltieId}/logs`, 0);

const exportarXlsx = async (filtro) => {
    const token = getTokenCookie();
    if (!token || !token.accessToken) {
        return { ok: false, message: "Sessão expirada." };
    }

    const url = process.env.REACT_APP_API_ENDPOINT + "api/" + ENDPOINT + "/xlsx";

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token.accessToken}`,
                tenantId: tenantId,
            },
            body: JSON.stringify(filtro),
        });

        if (!response.ok) {
            return { ok: false, message: "Erro ao exportar XLSX" };
        }

        const blob = await response.blob();
        return { ok: true, blob };
    } catch {
        return { ok: false, message: "Erro ao exportar XLSX" };
    }
};

export {
    getByEstabelecimento,
    criar,
    editar,
    getParcelas,
    atualizarStatusParcela,
    getLogs,
    exportarXlsx,
};
